module.exports = __webpack_public_path__ + "img/8.2684eb2e.jpg";